/**
 * Collection filters – OLD theme logic for collection-template
 * Drawer, Collapsible, toggle-tag, apply-tags, reset-tags, AJAX reload
 */
(function() {
  'use strict';

  var LAP_AND_UP = '(min-width: 1008px)';

  function matchesBreakpoint(media) {
    return window.matchMedia && window.matchMedia(media).matches;
  }

  function initCollectionFilters() {
    var sectionEl = document.querySelector('[data-section-type="collection"]');
    var filterDrawerEl = document.getElementById('collection-filter-drawer');
    var pageOverlayEl = document.querySelector('.PageOverlay');
    if (!sectionEl || !pageOverlayEl) return;

    var settings = {};
    try {
      settings = JSON.parse(sectionEl.getAttribute('data-section-settings') || '{}');
    } catch (err) {}
    var collectionUrl = settings.collectionUrl || '/collections/all';
    var currentTags = (settings.currentTags || []).slice();
    var currentSortBy = settings.sortBy || 'best-selling';
    var filterPosition = settings.filterPosition || 'sidebar';

    var temporaryTags = currentTags.slice();
    var toolbarEl = sectionEl.querySelector('.CollectionToolbar');
    var collectionInnerEl = sectionEl.querySelector('.CollectionInner__Products');
    var isDrawerOpen = false;
    var sortPopoverEl = document.getElementById('collection-sort-popover');
    var sortActivatorEl = sortPopoverEl ? document.querySelector('[aria-controls="collection-sort-popover"]') : null;
    var isSortPopoverOpen = false; 

    function openDrawer(e) {
      if (e) e.preventDefault();
      if (!filterDrawerEl || isDrawerOpen) return;
      isDrawerOpen = true;
      filterDrawerEl.setAttribute('aria-hidden', 'false');
      filterDrawerEl.style.maxHeight = window.innerHeight + 'px';
      document.documentElement.classList.add('no-scroll');
      pageOverlayEl.classList.add('is-visible');
      pageOverlayEl.addEventListener('click', closeDrawer);
      document.addEventListener('keydown', onDrawerKeydown);
    }

    function closeDrawer(e) {
      if (e) e.preventDefault();
      if (!filterDrawerEl || !isDrawerOpen) return;
      isDrawerOpen = false;
      filterDrawerEl.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('no-scroll');
      pageOverlayEl.classList.remove('is-visible');
      pageOverlayEl.removeEventListener('click', closeDrawer);
      document.removeEventListener('keydown', onDrawerKeydown);
      removeUncommittedTags();
    }

    function onDrawerKeydown(e) {
      if (e.keyCode === 27) closeDrawer(e);
    }

    function positionSortPopover() {
      var threshold = 20;
      var rect = sortActivatorEl.getBoundingClientRect();
      var windowHeight = window.innerHeight;
      var halfHeight = windowHeight / 2;
      var position = 'bottom';
      var alignment = 'right';
      var topPos = rect.bottom + threshold;
      var rightPos = window.innerWidth - rect.right;
      if (sortPopoverEl.clientHeight <= windowHeight - (rect.bottom + threshold) || windowHeight - rect.bottom >= halfHeight) {
        position = 'bottom';
      } else {
        position = 'top';
        topPos = rect.top - sortPopoverEl.clientHeight - threshold;
      }
      ['Popover--positionBottom', 'Popover--positionTop', 'Popover--positionCenter', 'Popover--alignTop', 'Popover--alignCenter', 'Popover--alignBottom'].forEach(function(c) { sortPopoverEl.classList.remove(c); });
      sortPopoverEl.classList.add('Popover--position' + (position.charAt(0).toUpperCase() + position.slice(1)));
      sortPopoverEl.classList.add('Popover--align' + (alignment.charAt(0).toUpperCase() + alignment.slice(1)));
      sortPopoverEl.style.top = parseInt(topPos, 10) + 'px';
      sortPopoverEl.style.right = parseInt(rightPos, 10) + 'px';
    }

    function openSortPopover() {
      if (!sortPopoverEl || !sortActivatorEl || isSortPopoverOpen) return;
      isSortPopoverOpen = true;
      sortPopoverEl.setAttribute('aria-hidden', 'false');
      sortActivatorEl.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('no-scroll');
      if (!matchesBreakpoint(LAP_AND_UP)) {
        sortPopoverEl.removeAttribute('style');
        pageOverlayEl.classList.add('is-visible');
        pageOverlayEl.addEventListener('click', closeSortPopover);
      } else {
        positionSortPopover();
        document.body.addEventListener('click', onSortPopoverClickOutside);
      }
      document.addEventListener('keydown', onSortPopoverKeydown);
    }

    function closeSortPopover() {
      if (!isSortPopoverOpen) return;
      isSortPopoverOpen = false;
      sortPopoverEl.setAttribute('aria-hidden', 'true');
      if (sortActivatorEl) sortActivatorEl.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('no-scroll');
      pageOverlayEl.classList.remove('is-visible');
      pageOverlayEl.removeEventListener('click', closeSortPopover);
      document.body.removeEventListener('click', onSortPopoverClickOutside);
      document.removeEventListener('keydown', onSortPopoverKeydown);
    }

    function onSortPopoverKeydown(e) {
      if (e.keyCode === 27) closeSortPopover();
    }

    function onSortPopoverClickOutside(e) {
      if (!sortActivatorEl) return;
      if (!e.target.closest('.Popover') && !e.target.closest('.Modal') && e.target !== sortActivatorEl && !sortActivatorEl.contains(e.target)) {
        closeSortPopover();
      }
    }

    function sortByChanged(sortBy) {
      if (currentSortBy === sortBy) return;
      currentSortBy = sortBy;
      closeSortPopover();
      reloadProducts();
    }

    function removeUncommittedTags() {
      temporaryTags = currentTags.slice();
      updateActiveTags();
    }

    function toggleCollapsible(button) {
      var parent = button.closest('.Collapsible');
      if (!parent) return;
      var inner = parent.querySelector('.Collapsible__Inner');
      var toggleBtn = parent.querySelector('.Collapsible__Button');
      if (!inner || !toggleBtn) return;

      var expanded = toggleBtn.getAttribute('aria-expanded') === 'true';

      if (expanded) {
        toggleBtn.setAttribute('aria-expanded', 'false');
        inner.style.overflow = 'hidden';
        inner.style.height = '0px';
      } else {
        toggleBtn.setAttribute('aria-expanded', 'true');
        inner.style.overflow = 'visible';
        inner.style.height = inner.scrollHeight + 'px';
        var siblings = parent.parentNode ? Array.from(parent.parentNode.children).filter(function(el) {
          return el !== parent && el.classList && el.classList.contains('Collapsible');
        }) : [];
        siblings.forEach(function(sib) {
          var sibBtn = sib.querySelector('.Collapsible__Button');
          var sibInner = sib.querySelector('.Collapsible__Inner');
          if (sibBtn && sibInner && sibBtn.getAttribute('aria-expanded') === 'true') {
            sibBtn.setAttribute('aria-expanded', 'false');
            sibInner.style.overflow = 'hidden';
            sibInner.style.height = '0px';
          }
        });
      }
    }

    function toggleTag(event) {
      var el = event.target;
      var tag = el.getAttribute('data-tag');
      if (!tag) return;

      if (el.classList.contains('is-active')) {
        var idx = temporaryTags.indexOf(tag);
        if (idx > -1) temporaryTags.splice(idx, 1);
      } else {
        var collapsible = el.closest('.Collapsible');
        var activeSibling = collapsible ? collapsible.querySelector('.is-active') : null;
        if (activeSibling) {
          var activeTag = activeSibling.getAttribute('data-tag');
          if (activeTag) {
            var ai = temporaryTags.indexOf(activeTag);
            if (ai > -1) temporaryTags.splice(ai, 1);
          }
        }
        temporaryTags.push(tag);
      }

      updateActiveTags();

      if (matchesBreakpoint(LAP_AND_UP) && filterPosition === 'sidebar') {
        commit();
      }
    }

    function updateActiveTags() {
      var items = sectionEl.querySelectorAll('.CollectionFilters [data-tag]');
      items.forEach(function(item) {
        var tag = item.getAttribute('data-tag');
        if (temporaryTags.indexOf(tag) > -1) {
          item.classList.add('is-active');
          if (item.parentNode) item.parentNode.classList.add('is-selected');
        } else {
          item.classList.remove('is-active');
          if (item.parentNode) item.parentNode.classList.remove('is-selected');
        }
      });
    }

    function applyTags() {
      updateActiveTags();
      commit();
    }

    function resetTags() {
      temporaryTags = [];
      applyTags();
    }

    function commit() {
      var currStr = currentTags.slice().sort().join(',');
      var tempStr = temporaryTags.slice().sort().join(',');
      if (currStr !== tempStr) {
        currentTags = temporaryTags.slice();
        reloadProducts();
      }
      if (isDrawerOpen) closeDrawer();
      var resetBtns = sectionEl.querySelectorAll('[data-action="reset-tags"]');
      resetBtns.forEach(function(btn) {
        btn.style.display = currentTags.length === 0 ? 'none' : 'block';
      });
    }

    function reloadProducts() {
      document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));

      var filterBtn = toolbarEl ? toolbarEl.querySelector('.CollectionToolbar__Item--filter') : null;
      if (filterBtn) {
        var countSpan = filterBtn.querySelector('span');
        if (countSpan) countSpan.remove();
        if (currentTags.length === 0) {
          filterBtn.classList.add('Text--subdued');
        } else {
          filterBtn.classList.remove('Text--subdued');
          filterBtn.innerHTML += '<span class="Text--subdued">(' + currentTags.length + ')</span>';
        }
      }

      var tags = currentTags.length > 0 ? currentTags.join('+') : '';
      var newUrl = window.location.protocol + '//' + window.location.host + collectionUrl + (tags ? '/' + tags : '') + '?sort_by=' + currentSortBy;
      if (history.replaceState) {
        window.history.pushState({ path: newUrl }, '', newUrl);
      }

      var fetchUrl = (tags ? collectionUrl + '/' + tags : collectionUrl.replace(/\/$/, '')) + '?view=ajax&sort_by=' + currentSortBy;
      fetch(fetchUrl, { credentials: 'same-origin', method: 'GET' })
        .then(function(res) { return res.text(); })
        .then(function(html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var newContent = doc.querySelector('.shopify-section') ? doc.querySelector('.shopify-section').innerHTML : (doc.body ? doc.body.innerHTML : html);
          if (collectionInnerEl && newContent) {
            collectionInnerEl.innerHTML = newContent;
          }
          document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
          var collectionMain = sectionEl.querySelector('.CollectionMain');
          if (collectionMain) {
            var rect = collectionMain.getBoundingClientRect();
            var headerHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height') || '0', 10);
            var offset = rect.top - headerHeight;
            if (offset < 0 && matchesBreakpoint(LAP_AND_UP) && toolbarEl && toolbarEl.clientHeight === 0) {
              offset -= 50;
            }
            if (offset < 0) {
              window.scrollBy({ top: offset, behavior: 'smooth' });
            }
          }
        })
        .catch(function() {
          window.location.href = newUrl;
        });
    }

    function onBodyClick(e) {
      var target = e.target;
      var openBtn = target.closest && target.closest('[data-action="open-drawer"][data-drawer-id="collection-filter-drawer"]');
      var closeBtn = target.closest && target.closest('[data-action="close-drawer"][data-drawer-id="collection-filter-drawer"]');
      var toggleCollBtn = target.closest && target.closest('[data-action="toggle-collapsible"]');
      var toggleTagBtn = target.closest && target.closest('[data-action="toggle-tag"]');
      var applyBtn = target.closest && target.closest('[data-action="apply-tags"]');
      var resetBtn = target.closest && target.closest('[data-action="reset-tags"]');
      var sortToggleBtn = target.closest && target.closest('[aria-controls="collection-sort-popover"]');
      var sortCloseBtn = sortPopoverEl && target.closest && target.closest('#collection-sort-popover [data-action="close-popover"]');
      var sortSelectBtn = sortPopoverEl && target.closest && target.closest('#collection-sort-popover [data-action="select-value"]');

      if (openBtn) {
        e.preventDefault();
        openDrawer(e);
      } else if (closeBtn) {
        e.preventDefault();
        closeDrawer(e);
      } else if (toggleCollBtn) {
        e.preventDefault();
        toggleCollapsible(toggleCollBtn);
      } else if (toggleTagBtn) {
        e.preventDefault();
        toggleTag(e);
      } else if (applyBtn) {
        e.preventDefault();
        applyTags();
      } else if (resetBtn) {
        e.preventDefault();
        resetTags();
      } else if (sortToggleBtn) {
        e.preventDefault();
        if (isSortPopoverOpen) closeSortPopover(); else openSortPopover();
      } else if (sortCloseBtn) {
        e.preventDefault();
        closeSortPopover();
      } else if (sortSelectBtn) {
        e.preventDefault();
        var value = sortSelectBtn.getAttribute('data-value');
        if (value) {
          var list = sortPopoverEl.querySelector('.Popover__ValueList');
          if (list) {
            list.querySelectorAll('.Popover__Value.is-selected').forEach(function(el) { el.classList.remove('is-selected'); });
            sortSelectBtn.classList.add('is-selected');
          }
          sortByChanged(value);
        }
      }
    }

    document.body.addEventListener('click', onBodyClick);

    var sidebarEl = sectionEl.querySelector('.CollectionInner__Sidebar');
    var sidebarScroller = null;

    function getInitialTopOffset(el) {
      var headerHeight = parseInt(window.getComputedStyle(document.documentElement).getPropertyValue('--header-height') || '0', 10) || 0;
      var useStickyHeader = parseFloat(window.getComputedStyle(document.body).getPropertyValue('--use-sticky-header') || '0') || 0;
      var hasTopToolbar = el && el.classList.contains('CollectionInner__Sidebar--withTopToolbar');
      var top = hasTopToolbar ? (headerHeight * useStickyHeader + 105) : (headerHeight + 50);
      return Math.max(top, 210);
    }

    function centerSidebarAndInitScroller() {
      if (filterPosition !== 'sidebar' || !sidebarEl || !matchesBreakpoint(LAP_AND_UP)) {
        if (sidebarScroller && sidebarScroller.destroy) sidebarScroller.destroy();
        sidebarScroller = null;
        return;
      }
      var initialTop = getInitialTopOffset(sidebarEl);
      sidebarEl.style.top = initialTop + 'px';

      if (sidebarScroller && sidebarScroller.destroy) sidebarScroller.destroy();
      sidebarScroller = (function() {
        var el = sidebarEl;
        var lastY = window.scrollY;
        var currentTop = initialTop;
        var initialTopVal = initialTop;
        var raf = null;

        function check() {
          var rect = el.getBoundingClientRect();
          var maxTop = rect.top + window.scrollY - el.offsetTop + initialTopVal;
          var minTop = el.clientHeight - window.innerHeight;
          if (window.scrollY < lastY) {
            currentTop -= window.scrollY - lastY;
          } else {
            currentTop += lastY - window.scrollY;
          }
          currentTop = Math.min(Math.max(currentTop, -minTop), maxTop, initialTopVal);
          lastY = window.scrollY;
          el.style.top = currentTop + 'px';
        }

        function onScroll() {
          if (raf) return;
          raf = requestAnimationFrame(function() {
            raf = null;
            check();
          });
        }

        check();
        window.addEventListener('scroll', onScroll, { passive: true });
        return {
          destroy: function() {
            window.removeEventListener('scroll', onScroll);
            if (raf) cancelAnimationFrame(raf);
          },
          refresh: function() {
            if (matchesBreakpoint(LAP_AND_UP)) {
              initialTopVal = getInitialTopOffset(el);
              currentTop = initialTopVal;
              lastY = window.scrollY;
              el.style.top = initialTopVal + 'px';
              check();
            }
          }
        };
      })();
    }

    centerSidebarAndInitScroller();

    window.addEventListener('resize', function() {
      if (isDrawerOpen && filterDrawerEl) filterDrawerEl.style.maxHeight = window.innerHeight + 'px';
      if (sidebarScroller && sidebarScroller.refresh) sidebarScroller.refresh();
      else centerSidebarAndInitScroller();
    });

    window.addEventListener('popstate', function(e) {
      if (e.state && e.state.path) {
        window.location.href = e.state.path;
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCollectionFilters);
  } else {
    initCollectionFilters();
  }
})();
